<div class="d-flex cta pointer w-100 mat-background-accent-500 justify-content-center align-items-center font-weight-bold pointer">
	<ng-content></ng-content>
</div>
